import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

export const AuthContext = React.createContext<AuthAPI>({
    refresh: () => {},
});

export interface AuthAPI {
    refresh: () => void;
}

export interface AuthProps {
    authAPI: AuthAPI;
}

// tslint:disable-next-line max-line-length
export function connectWithAuth<Props>(Component: React.ComponentType<Props & AuthProps>) {
    class AuthConnectedComponent extends React.PureComponent<Props> {
        private renderComponent = (authAPI: AuthAPI) => (
            <Component
                authAPI={authAPI}
                {...this.props}
            />
        )

        public render() {
            return (
                <AuthContext.Consumer>
                    {this.renderComponent}
                </AuthContext.Consumer>
            );
        }
    }

    return hoistNonReactStatics<React.ComponentType<Props>, React.ComponentType<Props & AuthProps>>(
        AuthConnectedComponent,
        Component,
    );
}
